var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolidShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 32,
    viewBox: "0 0 64 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6844 19.7895C55.2478 19.7895 56.7472 19.1684 57.8527 18.0629C58.9581 16.9575 59.5792 15.4581 59.5792 13.8947C59.5792 12.3314 58.9581 10.832 57.8527 9.72653C56.7472 8.62105 55.2478 8 53.6844 8C52.1211 8 50.6217 8.62105 49.5162 9.72653C48.4108 10.832 47.7897 12.3314 47.7897 13.8947C47.7897 15.4581 48.4108 16.9575 49.5162 18.0629C50.6217 19.1684 52.1211 19.7895 53.6844 19.7895ZM51.5798 22C47.0437 22 43.3687 25.675 43.3687 30.2112C43.3687 30.9664 43.9812 31.5789 44.7364 31.5789H62.6325C63.3877 31.5789 64.0002 30.9664 64.0002 30.2112C64.0002 25.675 60.3252 22 55.789 22H51.5798Z",
    fill: "#6F0816"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_148_14958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3158 19.7895C11.8792 19.7895 13.3785 19.1684 14.484 18.0629C15.5895 16.9575 16.2105 15.4581 16.2105 13.8947C16.2105 12.3314 15.5895 10.832 14.484 9.72653C13.3785 8.62105 11.8792 8 10.3158 8C8.75241 8 7.25306 8.62105 6.14758 9.72653C5.0421 10.832 4.42105 12.3314 4.42105 13.8947C4.42105 15.4581 5.0421 16.9575 6.14758 18.0629C7.25306 19.1684 8.75241 19.7895 10.3158 19.7895ZM8.21118 22C3.675 22 0 25.675 0 30.2112C0 30.9664 0.6125 31.5789 1.36776 31.5789H19.2638C20.0191 31.5789 20.6316 30.9664 20.6316 30.2112C20.6316 25.675 16.9566 22 12.4204 22H8.21118Z",
    fill: "#6F0816"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_148_14958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5 17.2857C41.3944 17.2857 43.2112 16.5332 44.5508 15.1936C45.8903 13.8541 46.6429 12.0373 46.6429 10.1429C46.6429 8.24845 45.8903 6.43164 44.5508 5.09209C43.2112 3.75255 41.3944 3 39.5 3C37.6056 3 35.7888 3.75255 34.4492 5.09209C33.1097 6.43164 32.3571 8.24845 32.3571 10.1429C32.3571 12.0373 33.1097 13.8541 34.4492 15.1936C35.7888 16.5332 37.6056 17.2857 39.5 17.2857ZM36.9498 19.9643C31.4531 19.9643 27 24.4174 27 29.9141C27 30.8292 27.7422 31.5714 28.6574 31.5714H50.3426C51.2578 31.5714 52 30.8292 52 29.9141C52 24.4174 47.5469 19.9643 42.0502 19.9643H36.9498Z",
    fill: "#AA182C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_148_14958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9716 15.9674C25.089 15.9674 27.1197 15.1263 28.617 13.629C30.1142 12.1318 30.9554 10.1011 30.9554 7.98366C30.9554 5.86624 30.1142 3.83554 28.617 2.33829C27.1197 0.841045 25.089 -9.91821e-05 22.9716 -9.91821e-05C20.8542 -9.91821e-05 18.8235 0.841045 17.3262 2.33829C15.829 3.83554 14.9878 5.86624 14.9878 7.98366C14.9878 10.1011 15.829 12.1318 17.3262 13.629C18.8235 15.1263 20.8542 15.9674 22.9716 15.9674ZM20.1211 18.9613C13.9774 18.9613 9 23.9387 9 30.0825C9 31.1054 9.82956 31.935 10.8525 31.935H35.0907C36.1136 31.935 36.9432 31.1054 36.9432 30.0825C36.9432 23.9387 31.9658 18.9613 25.822 18.9613H20.1211Z",
    fill: "#CC7480"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6316,
    height: 23.5789,
    fill: "white",
    transform: "translate(43.3687 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_148_14958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6316,
    height: 23.5789,
    fill: "white",
    transform: "translate(0 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_148_14958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 28.5714,
    fill: "white",
    transform: "translate(27 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_148_14958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9432,
    height: 31.9351,
    fill: "white",
    transform: "translate(9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolidShared);
export default __webpack_public_path__ + "static/media/user-solid-shared.1b1cfded5c6c84945e92fe3b0234ddf8.svg";
export { ForwardRef as ReactComponent };